import { render, staticRenderFns } from "./PoiTypeOption.vue?vue&type=template&id=547688fc&scoped=true&"
import script from "./PoiTypeOption.vue?vue&type=script&lang=js&"
export * from "./PoiTypeOption.vue?vue&type=script&lang=js&"
import style0 from "./PoiTypeOption.vue?vue&type=style&index=0&id=547688fc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547688fc",
  null
  
)

export default component.exports